import {backAdmin} from "../axios";

export const purchasesApi = [
    {url: `${backAdmin}/purchases`, name: 'purchases.all', method: 'GET'},
    {url: `${backAdmin}/purchases/{id}/download-invoice`, name: 'purchases.download.invoice', method: 'GET'},
    {url: `${backAdmin}/purchases/export`, name: 'purchases.export', method: 'GET'},
]